import { Link } from "react-router-dom";

export const Logo = ({ light = false, className = "h-9 md:h-10" }) => (
  <Link to="/" aria-label="PACTORA Personalpartner – zur Startseite" data-testid={light ? "footer-logo" : "header-logo"} className="inline-flex shrink-0">
    <img
      src={light ? "/brand/logo-light.webp" : "/brand/logo.webp"}
      alt="PACTORA Personalpartner"
      width="640" height="145"
      className={`${className} w-auto`}
    />
  </Link>
);
